import { render, staticRenderFns } from "./CatalogReservationConfigModal.vue.html?vue&type=template&id=60dd20e6&"
import script from "./CatalogReservationConfigModal.component.js?vue&type=script&lang=vueJs&"
export * from "./CatalogReservationConfigModal.component.js?vue&type=script&lang=vueJs&"
import style0 from "./CatalogReservationConfigModal.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports